import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";
import { Switch } from "../../../components/inputs/final_form/Switch";
import { Fieldset } from "../../../components/inputs/final_form/Fieldset";

export const AddPayorsModal = ({ clinicId, onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleAdd = async (params) => {
    setError(null);

    try {
      const payorId = params.payorId;
      const createParams = { clinicId, payorId, ...params };

      const { data } = await api.post(`/admin/clinic_payor_permissions/`, snakifyKeys(createParams));

      if (onAdd) {
        onAdd(data.meta.message);
      }

      setOpen(false);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Payors
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Payors</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleAdd}>
            {({ handleSubmit, submitting }) => {
              return (
                <>
                  <Field
                    component={AdminOptionableInput}
                    resource="payors"
                    label="Payors"
                    name="payorId"
                    searchParam="name"
                    required
                    isMulti
                  />
                  <Field component={Switch} label="Add all payors" name="addAllPayors" id="add-all-payors" type="checkbox" />
                  <Field component={Switch} label="Reflex to PA" name="reflexToPa" id="reflex-to-pa" type="checkbox" />

                  <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                    Submit
                  </LoadingButton>
                </>
              );
            }}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
